import { AvatarProps, Avatar as CAvatar } from '@chakra-ui/react';
import useHasImageLoaded from '~/hooks/useHasImageLoaded';

interface Props extends AvatarProps {
  src?: string;
  fallbackSrc?: string;
}

const Avatar: React.FC<Props> = ({ src, fallbackSrc, ...rest }) => {
  const hasLoaded = useHasImageLoaded({
    src,
  });

  return (
    <CAvatar
      src={hasLoaded ? src : fallbackSrc}
      backgroundColor={hasLoaded || !fallbackSrc ? undefined : 'gray.400'}
      {...rest}
    />
  );
};

export default Avatar;
